import axios from "axios"
import { getToken, logout } from "../helpers/utility";
export const init = () => {
    const token = getToken()
    console.log(token);
    axios.defaults.headers.get['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.post['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.put['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.delete['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.delete['Content-Type'] = `application/json;charset=UTF-8`;
}
init()
// The API now answers an expired or missing session with HTTP 401 instead of a
// 200 "Unathorized access" body, so one interceptor replaces the per-action string checks.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error && error.response && error.response.status === 401) {
            logout()
        }
        return Promise.reject(error)
    },
)
export const  http = axios
